<script>
import {Routes} from '@/router'

export default {
  computed: {
    child_routes() {
      // Returns all child routes for this doc viewer
      const parent_route = this.$router.options.routes
        .filter(r => r.name === Routes.Dashboard.name)
      const routes = parent_route[0].children
        .filter(r => r.name === Routes.Docs.name)
      return routes[0].children
        .filter(r => r.name === this.route_name)[0].children
    },
    index() {
      // Returns either the index route or the first route from child_routes
      return (
        this.child_routes.filter(r => r.name === `${this.route_name}-index`)[0]
          || this.child_routes[0]
      )
    }
  },
  methods: {
    on_route_update() {
      if(this.$route.name === this.route_name) {
        this.$router.push({name: this.index.name})
      }
    }
  },
  mounted() {
    this.on_route_update()
  },
  name: 'doc-viewer',
  props: {
    route_name: {type: String, default: null}
  },
  watch: {
    $route() {
      this.on_route_update()
    }
  }
}
</script>

<template>
<div class='doc-viewer'>
  <router-view/>
</div>
</template>

<style lang='sass' scoped>
.doc-viewer
  .theme--light
    color: var(--v-grey-base)

  .theme--dark
    color: red !important
</style>
